import React, { useState } from 'react'; // 1. Import useState
import { Link } from 'react-router-dom';
import PrivacyPolicy from './privacy';
import TermsOfService from './Terms';

export default function Legal() {
  // 2. Set up state (default to 'privacy' or null)
  const [activeTab, setActiveTab] = useState('privacy');

  return (
    <div style={{ 
      padding: '0px', 
      maxWidth: '100%', 
      margin: '0 auto',
      marginTop: '64px',
      minHeight: '80vh',
      backgroundColor: 'white'
    }}>
      {/* Header Section */}
      <div style={{ width: "100%", textAlign: "center", letterSpacing: "0.5px", padding: "40px", backgroundColor: "#191f37", marginBottom: "40px" }}>
        <h1 style={{ color: "white", fontSize: "2.5rem", marginBottom: "0.5rem" }}>Shepherd Legal Hub</h1>
        <p style={{ color: "white", width: "60%", margin: "0 auto", marginTop: "20px", fontSize: "1.1rem", lineHeight: "1.6" }}>
The information provided here, in Shepherd's legal Hub is for customers and users wanting to see our terms & conditions, privacy policy.        </p>
      </div>

      <div style={{ display: 'flex', gap: '2rem', padding: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
        
        {/* Sidebar Menu */}
        <div style={{ width: "25%", boxShadow: "0 2px 4px rgba(0,0,0,0.3)", borderRadius: "8px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div style={{ width: "100%", height: "10px", backgroundColor: "#1a73e8" }}></div>
          
          <button 
            style={{ ...styles.tabButton, fontWeight: activeTab === 'privacy' ? 'bold' : 'normal' }} 
            onClick={() => setActiveTab('privacy')} // 3. Update state on click
          >
            Privacy Policy
          </button>
          
          <button 
            style={{ ...styles.tabButton, fontWeight: activeTab === 'terms' ? 'bold' : 'normal' }} 
            onClick={() => setActiveTab('terms')} // 3. Update state on click
          >
            Terms of Service
          </button>
        </div>

        {/* 4. Content Container: Shows component based on activeTab */}
        <div className='legal-content-container' style={{ width: "65%", minHeight: "400px" }}>
          {activeTab === 'privacy' && <PrivacyPolicy />}
          {activeTab === 'terms' && <TermsOfService />}
        </div>

      </div>
    </div>
  );
};

// Simple styles for the sidebar buttons
const styles = {
  tabButton: {
    padding: "1rem",
    textAlign: "left",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    borderBottom: "1px solid #eee"
  }
};

